import React, { useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import api from "../../services/api";
import styles from "./style.module.css";
import useWrapper from "../../hooks/useWrapper";
import ModalCustom from "./modal-template-default";
import { InputTextArea } from "../Input";
import Button from "../Button";
import { toast } from "react-toastify";

export default function ModalPrivateComment(props) {
  const { show, closeModal, id } = props;
  const { me, config } = useWrapper();

  const [isLoadingSave, setisLoadingSave] = useState();

  const [privateComment, setprivateComment] = useState();
  const onHide = () => {
    closeModal();
    setprivateComment();
  };

  async function sendPrivateComment() {
    if (!privateComment) return;
    try {
      setisLoadingSave(true);
      await api.post(
        "attendance-messages",
        {
          message: privateComment,
          private: true,
          attendance_id: id,
          user_id: me?.id,
        },
        config,
      );
      toast.success("Comentário Privado criado com sucesso!");
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar criar um comentário privado.");
    } finally {
      setisLoadingSave(false);
      onHide();
    }
  }

  return (
    <ModalCustom size="lg" show={show} onHide={onHide} disableClose={!!isLoadingSave}>
      <ModalCustom.Header>
        <h2 className="page-title">Comentário Privado</h2>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <Container>
          <p className="small-label m-0 mb-3">
            <b>Apenas Gestores</b> poderão ler essas mensagens e formandos não possuem acesso a elas.
          </p>
          <div>
            <Row>
              <Col>
                <div className={styles.writeComment}>
                  <InputTextArea
                    autoFocus
                    required={true}
                    disabled={!!isLoadingSave}
                    rows={4}
                    value={privateComment || ""}
                    onChange={__ev => {
                      setprivateComment(__ev.target.value);
                    }}
                    placeholder="Escreva o seu comentário privado"
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <Button disabled={!privateComment} loading={!!isLoadingSave} color={"primary"} onClick={sendPrivateComment}>
          Adicionar Comentário
        </Button>
      </ModalCustom.Footer>
    </ModalCustom>
  );
}
